(ns teamoesterreich.admin-mode.detail-filter.cat-filter
  (:require ["react-virtualized" :as rv]
            [clojure.string]
            [reagent-material-ui.components :as mui]
            [goog.date.DateTime]
            [reagent.core :as r]
            [teamoesterreich.util.helper :as h] ;;(h/event-value e)
            [teamoesterreich.view-state :as vstate]
            [teamoesterreich.admin-mode.toe-list.toe-sort-table :as table]
            [reagent-material-ui.icons.add :as add]
            [teamoesterreich.admin-mode.static-data :as staticData]
            [teamoesterreich.util.log :as log]))




(defn wait-do [!waiting? !loaded? event-fn]
  (fn [e]
    (let [val (h/event-value e)]
      (js/console.log "wait or do" @!waiting?)
      (when @!waiting? (js/clearTimeout @!waiting?))
      (reset! !waiting?
              (js/setTimeout
                (fn []
                  (event-fn val)
                  (reset! !waiting? false)
                  (reset! !loaded? false))
                500)))))

(defn wait-do-check [!waiting? !loaded? event-fn]
  (fn [e val]
      (js/console.log "wait or do" val)
      (event-fn val)
      (reset! !waiting? false)
      (reset! !loaded? false)))


(defn check-box [!waiting? !loaded? !detail-search name add-filter-key]

  [mui/form-control-label {:label name :value "dst" :placement "start"
                           :control (r/as-element [mui/checkbox {:checked (get-in @!detail-search [:add-filter-cat add-filter-key])
                                                                 :onChange (wait-do-check !waiting? !loaded? (fn [val] (swap! !detail-search assoc-in [:add-filter-cat add-filter-key] val)))
                                                                 }])}]

  )



(defn cat-block [!detail-search !waiting? !loaded?]
  [mui/grid
   {:item true
    :xs 12
    :style {:marginBottom "7px"}
    }

   [mui/paper
    [mui/grid
     {:container true
      :direction "row"
      :alignItems "flex-start"
      :justify "flex-start"
      :spacing 1
      :style {:padding "5px"}
      }

     [mui/grid
      {:item true
       :lg 2
       :md 3
       :xs 6
       }
      [mui/typography "Katastrophenschutz"]
      ]
     [mui/grid
      {:item true
       :md 9
       :xs 6
       }

      [mui/form-control
       {
        :component "fieldset"
        :fullWidth true
        }
       [mui/radio-group {:row true :class "filterRadio"}


        [check-box !waiting? !loaded? !detail-search "Administrativ" :helpingKatAdministrativ]
        [check-box !waiting? !loaded? !detail-search "Informationstätigkeiten" :helpingKatInformationstgk]
        [check-box !waiting? !loaded? !detail-search "Logistik" :helpingKatLogistik]
        [check-box !waiting? !loaded? !detail-search "Sicherungsarbeiten" :helpingKatSicherungsarbeiten]
        [check-box !waiting? !loaded? !detail-search "Aufraeumungsarbeiten" :helpingKatAufraeumungsarbeiten]
        [check-box !waiting? !loaded? !detail-search "Hilfsaktivitaeten" :helpingKatHilfsaktivitaeten]

        ]

       ]

      ]]]])